export default [
  {
    city: "theran",
    region: "theran",
    country_name: "Iran",
    count: 12,
  },
  {
    city: "Qazvin",
    region: "Qazvin",
    country_name: "Iran",
    count: 15,
  },
  {
    city: "shar ghods",
    region: "theran",
    country_name: "Iran",
    count: 41,
  },
];
